import useAPI, { useAPIMutation } from "@/services/api/hook";
import { ExtendedUseQueryResult } from "@/services/api/types";

// Action-button state for a lead-suggestion candidate. The buttons derive
// their taken/reversible state from the candidate row (via this endpoint),
// not from the per-recipient message copies.
export interface LeadCandidateActionState {
  candidateId: string;
  createdLeadId: string | null;
  leadName: string | null;
  rejected: boolean;
  rejectedAt: string | null;
}

interface LeadCandidateActionStatesResponse {
  candidates: LeadCandidateActionState[];
}

export const useLeadCandidateActionState = (
  candidateId: string,
  enabled: boolean
): ExtendedUseQueryResult<LeadCandidateActionStatesResponse> =>
  useAPI(
    "leads/candidateActionStates",
    { method: "GET", queryParams: { ids: candidateId } },
    { enabled }
  );

type CandidateActionVariables = { pathParams: { candidateId: string } };

export const useLeadCandidateAcceptMutation = () =>
  useAPIMutation<CandidateActionVariables, LeadCandidateActionState>(
    "leads/candidateAccept",
    { method: "PUT" }
  );

export const useLeadCandidateUnacceptMutation = () =>
  useAPIMutation<CandidateActionVariables, LeadCandidateActionState>(
    "leads/candidateAccept",
    { method: "DELETE" }
  );

export const useLeadCandidateRejectMutation = () =>
  useAPIMutation<CandidateActionVariables, LeadCandidateActionState>(
    "leads/candidateReject",
    { method: "PUT" }
  );

export const useLeadCandidateUnrejectMutation = () =>
  useAPIMutation<CandidateActionVariables, LeadCandidateActionState>(
    "leads/candidateReject",
    { method: "DELETE" }
  );
